import React, { useState } from "react";
import HttpsOutlinedIcon from "@mui/icons-material/HttpsOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import { ToastContainer, toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const Login = () => {
  const location = useLocation();
  React.useEffect(() => {
    if (location.state && location.state.message) {
      toast.success(location.state.message);
    }
  }, [location.state]);
  const apiUrl = process.env.REACT_APP_API_URL;
  const [loader, setLoader] = useState(false);
  const [inputType, setInputType] = useState("password");
  const togglePassword = () => {
    setInputType(inputType === "password" ? "text" : "password");
  };

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  window.localStorage.setItem("IsLoggedIn", isLoggedIn);

  let name, value;
  const handleChange = (event) => {
    event.preventDefault();
    name = event.target.name;
    value = event.target.value;
    setFormData({ ...formData, [name]: value });
  };

  const validateEmail = (input) => {
    const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
    return emailRegex.test(input);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const { email, password } = formData;
    if (!email || !password) {
      toast.error("Please fill all fields!");
    } else if (!validateEmail(email)) {
      toast.error("Email Address is not invalid!");
    } else {
      setLoader(true);
      try {
        const response = await axios.post(`${apiUrl}authAdminlogin`, formData);
        const data = response.data;
        if (response.status === 200 && data.message === "Login Successfully!") {
          setIsLoggedIn(true);
          window.localStorage.setItem("token", data.data);
          window.localStorage.setItem("IsLoggedIn", true);
          navigate("/admin/dashboard");
          toast.success("Login successfully!");
        } else {
          toast.error("Login failed.");
          setLoader(false);
        }
      } catch (error) {
        setLoader(false);
        if (error.response && error.response.status === 401) {
          toast.error(error.response.data.message);
        } else if (error.response && error.response.status === 404) {
          toast.error(error.response.data.message);
        } else {
          console.error(error);
          toast.error("Login failed. Please try again.");
        }
      }
    }
  };

  return (
    <div class="dashboard-login w-full h-full bg-[#FAFBFB] flex items-center justify-center flex-col gap-5">
      <ToastContainer />
      <div className="bg-blue-600 rounded-full h-11 w-11 text-white flex justify-center items-center">
        <HttpsOutlinedIcon sx={{ fontSize: "21px" }} />
      </div>
      <div className="text-center">
        <h1 className="font-bold text-[18px]">Sign In</h1>
        <p className="text-sm opacity-70 mt-1">
          Welcome user, please sign in to continue
        </p>
      </div>
      <form method="post" className="bg-white form-admin-login">
        <div class="form-group mb-5">
          <label className="text-sm mb-2 pl-1 block">Email</label>
          <input
            type="email"
            name="email"
            className="form-control"
            placeholder="e.g: john@gmail.com"
            value={formData.email}
            onChange={handleChange}
          />
        </div>

        <div class="form-group mb-4">
          <label className="text-sm mb-2 pl-1 block">Password</label>
          <input
            type={inputType}
            name="password"
            className="form-control"
            placeholder="Enter Password"
            value={formData.password}
            onChange={handleChange}
          />
          <div className="togglePasswordIcon" onClick={togglePassword}>
            <span className="cursor-pointer text-gray-400">
              {inputType === "password" ? (
                <VisibilityOffOutlinedIcon sx={{ fontSize: "17px" }} />
              ) : (
                <VisibilityOutlinedIcon sx={{ fontSize: "17px" }} />
              )}
            </span>
          </div>
        </div>

        <button
          type="button"
          className="primary-bg shadow-lg px-6 py-3 text-sm rounded-lg text-white uppercase mt-7 w-full flex items-center justify-center"
          onClick={handleSubmit}
        >
          Login
          <LoginOutlinedIcon sx={{ marginLeft: "15px", fontSize: "20px" }} />
        </button>

        {loader && (
          <div className="loader-container">
            <div className="loader text-sm text-gray-400 text-center block mt-3">
              Request is in process please wait....
            </div>
          </div>
        )}
      </form>
    </div>
  );
};

export default Login;
